import { useSuspenseQuery } from "@tanstack/react-query";
import { axiosClient } from "@wayflyer/auth-sdk";
import { addError } from "@wayflyer/blackbox-fe";
import type { FundingApplicationSchemas } from "@wayflyer/api-types";

export const useFundingConfiguration = (customerDomain: string) => {
  return useSuspenseQuery(getFundingConfigurationQuery(customerDomain));
};

export const getFundingConfigurationQuery = (customerDomain: string) => {
  const url = `/${customerDomain}/funding/api/configuration/`;

  const queryFn = async () => {
    try {
      const data = await axiosClient.get<FundingApplicationSchemas.FundingConfigurationResponse>(url);
      return data.data;
    } catch (err) {
      addError(err);
      return null;
    }
  };

  return {
    queryKey: [url, customerDomain],
    queryFn,
  };
};
